"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchPart = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const _part_includes_1 = require("../_part_includes");
//@ts-ignore                
let rwsTemplate = T.html `<div class="part-switch">
    <button @click="${(x, c) => x.handleChange(c.event)}" type="button" role="switch" aria-checked="false"
        ?disabled="${x => x.disabled}"
        class="rc-switch custom-switch custom-switch-primary custom-switch-small${x => x.value ? ' rc-switch-checked' : ''}${x => x.disabled ? ' rc-switch-disabled' : ''}">
        <span class="rc-switch-inner"></span>
    </button>
    ${(0, fast_element_1.when)(x => x.label, (0, fast_element_1.html) `
    <label class="form-label">${x => x.label.t()}</label>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host-context(.force-placeholder) input::placeholder,
select::placeholder,
textarea::placeholder {
  opacity: 1 !important;
}

:host(.no-margin) .form-group {
  margin: 0 !important;
}

:host(.mini) .form-control {
  padding: 0.2rem 0.4rem;
  line-height: 0.8;
  font-size: 0.6rem;
}

:host(.rounded) .form-control {
  border-radius: 0.375rem;
}

input {
  width: var(--checkbox_size, inherit);
  height: var(--checkbox_size, inherit);
}

:host-context(.static) input {
  position: static !important;
}

.no-label {
  margin-left: 0;
}

.rc-switch-disabled {
  opacity: 0.6;
  cursor: not-allowed !important;
  pointer-events: none;
}
.rc-switch-disabled:hover {
  cursor: not-allowed !important;
}
.rc-switch-disabled .rc-switch-inner {
  cursor: not-allowed !important;
}

.part-switch {
  display: flex;
  align-items: center;
  gap: 15px;
}
.part-switch label {
  margin-bottom: 0;
}`;
const shadowOptions = { "mode": "open" };
let SwitchPart = class SwitchPart extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.value = false;
        this.ignored = 'false';
        this.dontEmit = false;
        this.disabled = false;
    }
    handleChange(event) {
        // Prevent action if disabled
        if (this.disabled) {
            return;
        }
        // The native click is composed and would otherwise also bubble past the
        // host, causing ancestor @click listeners to fire twice per toggle.
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        this.value = !this.value;
        const target = this.getElement();
        target.name = this.name;
        _part_includes_1.handlePartChange.bind(this)({ target, name: this.name });
        // Dispatch standard "change" event for broader compatibility
        // this.$emit('change', {
        //     value: this.value,
        //     name: this.name,
        //     element: target,
        //     formPartType: SwitchPart.PART_TYPE
        // });
        if (!this.dontEmit) {
            this.dispatchEvent(new CustomEvent('click', {
                detail: { checked: this.value },
                bubbles: true,
                composed: true
            }));
        }
    }
    ;
    getElement() {
        return this.$('button');
    }
    reset() {
        this.value = false;
    }
};
exports.SwitchPart = SwitchPart;
SwitchPart.PART_TYPE = 'switch';
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SwitchPart.prototype, "label", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SwitchPart.prototype, "name", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SwitchPart.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SwitchPart.prototype, "ignored", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], SwitchPart.prototype, "dontEmit", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], SwitchPart.prototype, "disabled", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], SwitchPart.prototype, "onChange", void 0);
exports.SwitchPart = SwitchPart = __decorate([
    (0, client_1.RWSView)('part-switch', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], SwitchPart);
SwitchPart.defineComponent();
